import { useTranslation } from "react-i18next";

import * as yup from "yup";

export const N01RegistrationValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    n01_firstname: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(2, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 2 χαρακτήρες")),
    n01_fathersname: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null))
      .min(2, "Το πεδίο πρέπει να είναι μεγαλύτερο απο 2 χαρακτήρες."),
    n01_lastname: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(2, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο δύο χαρακτήρες")),
    n01_email: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .email(t("Μη έγκυρο mail")),
    n01_username: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(7, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 7 χαρακτήρες")),
    n01_password1: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(7, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 7 χαρακτήρες")),
    n01_password2: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(7, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 7 χαρακτήρες"))
      .oneOf([yup.ref("n01_password1")], t("Ο κωδικός δεν είναι ίδιος")),
    n01_adtpassport: yup
      .string()
      .nullable()
      .min(3, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 3 χαρακτήρες")),
    n01_afm: yup
      .string()
      .matches(/^\d{9}$|^$/, t("Το πεδίο πρέπει να είναι αριθμός με 9 ψηφία"))
      .nullable()
      .notRequired(),
    n01_phone: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .transform((_, val) => (val !== "" ? val : null))
      .min(10, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 10 χαρακτήρες")),
    n01_mobilephone: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null))
      .min(10, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 10 χαρακτήρες")),
    n01_address_tk: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null))
      .matches(/^\d{5}$/, t("Το πεδίο πρέπει να αποτελείται από 5 ψηφία")),
    n01_address_city: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null)),
    n01_address_street: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null)),
    n01_address_number: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null)),
    n01_d06_code: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null)),
    recaptcha: yup
      .string()
      .required(t("Πρέπει να περάσετε τον έλεγχο CAPTCHA"))
      .transform((_, val) => (val !== "" ? val : null)),
  });
};

export const LegalPersonRegistrationValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    n01_lastname: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(2, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 2 χαρακτήρες")),
    n01_email: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .email(t("Μη έγκυρο mail")),
    n01_username: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(7, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 7 χαρακτήρες")),
    n01_password1: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(7, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 7 χαρακτήρες")),
    n01_password2: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(7, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 7 χαρακτήρες"))
      .oneOf([yup.ref("n01_password1")], t("Ο κωδικός δεν είναι ίδιος")),
    n01_afm: yup
      .string()
      .matches(/^\d{9}$|^$/, t("Το πεδίο πρέπει να είναι αριθμός με 9 ψηφία"))
      .nullable()
      .notRequired(),
    n01_phone: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .transform((_, val) => (val !== "" ? val : null))
      .min(10, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 10 χαρακτήρες")),
    n01_mobilephone: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null))
      .min(10, t("Το πεδίο πρέπει να είναι μεγαλύτερο απο 10 χαρακτήρες")),
    n01_address_tk: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null))
      .matches(/^\d{5}$/, t("Το πεδίο πρέπει να αποτελείται από 5 ψηφία")),
    n01_address_city: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null)),
    n01_address_street: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null)),
    n01_address_number: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null)),
    n01_d06_code: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null)),
    recaptcha: yup
      .string()
      .required(t("Πρέπει να περάσετε τον έλεγχο CAPTCHA"))
      .transform((_, val) => (val !== "" ? val : null)),
  });
};
